<template lang="html">
     <div class="statistics_3_3">
          <div class="ttBar">
             <span>{{ prevMs.name }} - {{ nameTrans() }}</span>
             <span class="dateSpan">（{{ dateTime }}）</span>
          </div>
          <div class="tabArea">
               <div class="tabTtl">
                   <span class="ttText">检索量统计</span>

                   <div class="timeArea">
                       <span>分页：</span>
                       <el-select v-model="params.no" size="small" @change="ssPostAct" placeholder="请选择">
                          <el-option
                            v-for="item in pageNumCage"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            :disabled="item.disabled">
                          </el-option>
                        </el-select>
                   </div>
              </div>
               <template>
                    <v-chart v-loading="loading" style="height:600px;width:100%;" :options="sortbar"/>
               </template>

          </div>
     </div>
</template>

<script>
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/bar';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip';
import { seekRank } from '@/api/statistics';
export default {
    components:{
        'v-chart':ECharts
    },
    data(){

         return{

             prevMs:{
                 code:'',
                 id:'',
                 name:''
             },

             loading:false,
             pageNumCage:[],

             params:{
                code:'LCP',
                organizationId:'',
                size:10,
                no:1,
                allPage:0
             },

             sortbar:{
                  tooltip: {
                      trigger: 'axis',
                      axisPointer: {
                          type: 'shadow'
                      }
                  },

                  grid: {
                      left: '180',
                      right: '50',
                      top:'60'
                  },
                  xAxis: {
                      name: '检索量',
                      type: 'value'
                  },
                  yAxis: {
                      name:'关键字',
                      type: 'category',
                      data: []
                  },
                  series: [
                      {
                          name: '',
                          type: 'bar',
                          data: [],
                          axisTick: {show: true},
                          itemStyle: {
                              normal: {
                                  color: '#4cabce',
                              }
                          },
                          label: {
                              normal: {

                                  show: true,
                                  position: 'inside'
                              }
                          },
                          barWidth: 30
                      }
                  ]
             }
         }
    },
    methods:{
         dateFormat:function(timeStr){
            let newTime = timeStr ? new Date(timeStr) : new Date();
            let y = newTime.getFullYear(),
                m = newTime.getMonth() + 1,
                d = newTime.getDate();

            if(m < 10){
                m = '0' + m;
            }

            if(d < 10){
                d = '0' + d;
            }

            return y + '-' + m + '-' + d;
         },
         ssPostAct:function(){
             this.loading = true;

             this.params.code = this.prevMs.code;
             this.params.organizationId = this.prevMs.id;

             seekRank(this.params).then(response => {
                  var unFormate = response.statisticsWordList.reverse();
                  this.params.allPage = response.totalPages;
                  var nameArr = [];
                  var numArr = [];
                  for(var i = 0;i < unFormate.length;i++){
                      nameArr.push(unFormate[i].title);
                      numArr.push(unFormate[i].play);
                  }

                  if(response.totalPages > 1){
                       this.pageNumCage = [];
                       for(var i = 0;i < response.totalPages;i++){
                            var temp = {
                                 label:'第' + ( i + 1 ) + '页',
                                 value:i + 1
                            };

                            this.pageNumCage.push(temp);
                       }
                  }

                  this.sortbar.yAxis.data = nameArr;
                  this.sortbar.series[0].data = numArr;

                  this.loading = false;
             })
         },

         nameTrans:function(){
             var nameMap = {
                 1:'中华民族音乐数据库',
                 3:'京剧绝版赏析数据库',
                 4:'中华戏曲老唱片数据库',
                 5:'中华曲艺老唱片数据库',
                 6:'丝绸之路上的民族音乐数据库'
             };
             return nameMap[this.$route.query.code];
         },

         typeChange:function(){
              this.params.no = 1;
              this.ssPostAct();
         }

    },
    created:function(){
         var codeMap = {
              1:'LCP',
              3:'JBSX',
              4:'XQ',
              5:'QY',
              6:'SCZL'
         };

         this.prevMs.id = this.$route.query.anysId;
         this.prevMs.code = codeMap[this.$route.query.code];
         this.prevMs.name = this.$route.query.name;

         this.dateTime = this.dateFormat();
         this.ssPostAct();
    }
}
</script>

<style lang="scss">
      .statistics_3_3{
           padding: 6px 12px;
           .ttBar{
                padding: 9px 12px 15px;

                border-bottom: 1px solid #e8e8e8;
                span{
                    font-size: 15px;
                    color: #666666;
                }

                .dateSpan{
                   font-size: 14px;
                   font-weight: bold;
                }
           }

           .tabArea{
                padding: 0px 12px;
                .tabTtl{
                     margin-top: 20px;
                    .timeArea{
                        display: inline-block;
                        font-size: 14px;
                        color: #666666;
                        margin-left: 24px;
                        margin-top: 20px;

                        .el-select{
                             width: 90px;
                        }
                    }
                    .ttText{
                      font-size: 15px;
                      font-weight: bold;
                    }
                }
                table{
                    width: 100%;
                    margin-top: 20px;
                    td{
                        position: relative;
                        border-collapse: collapse;
                        padding: 9px 12px;
                        border: 1px solid #efefef;
                        font-size: 14px;
                        text-align: center;
                    }

                    .tHead td{
                        background: #F8F8F8;
                    }
                }

                .echarts{
                    width: 100%;
                    height: 100%;
                }
           }
      }

</style>



// WEBPACK FOOTER //
// skText.vue?ff5e2718